import { Component, OnInit } from '@angular/core';
import { ReportesService } from 'src/app/services/reportes/reportes.service';
import { ListasService, UsuarioService } from 'src/app/services/service.index';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-reporte-creditos',
  templateUrl: './reporte-creditos.component.html',
  styles: [
  ]
})
export class ReporteCreditosComponent implements OnInit {

  colsGPA = [
    {field: 'nombre_cliente', header: 'Cliente'},
    {field: 'empresa', header: 'Empresa'},
    {field: 'monto', header: 'Monto'},
    {field: 'plazo', header: 'Plazo'},
    {field: 'term_type', header: 'Periodicidad'},
    {field: 'tasa', header: 'Tasa'},
    {field: 'estatus', header: 'Estado'},
  ];

  colsYucatan = [
    {header: 'Id de Crédito', field: 'id_credito'}, 
    {header: 'Nombre', field: 'nombre_cliente'},
    {header: 'RFC', field: 'rfc'},
    {header: 'Plazo crédito', field: 'plazo'},
    {header: 'Periodicidad crédito', field: 'term_type'},
    {header: 'Monto', field: 'monto'},
    {header: 'Dependencia', field: 'empresa'},
    {header: 'Fecha de Solicitud', field: 'fecha_solicitud'},
    {header: 'Estatus', field: 'estatus'},
    {header: 'Nombre de Promotor', field: 'promotor'},
    {header: 'Supervisor', field: 'supervisor'},
    {header: 'Fecha de Desembolso', field: 'fecha_desembolso'},
    {header: 'Fecha de termino de crédito', field: 'fecha_fin'},
    // {header: 'Fecha de Aprobación', field: ''},
  ];

  quotes = [];
  filteredQuotes = [];

  sortColumn: string = ''; // Columna actual de ordenación
  sortDirection: 'asc' | 'desc' = 'asc'; // Dirección de ordenación
  currentPage: number = 1;
  itemsPerPage: number = 10;
  searchTerm: string = '';
  maxVisiblePages: number = 8; // Número máximo de páginas visibles
  searchTerms = {
    nombre_cliente: '',
    empresa: '',
    monto: '',
    plazo: '',
    term_type: '',
    tasa: '',
    estatus: '',
    supervisor: '',
  };

  opcionSeleccionada = 'gpa';
  vendedores = [];
  doctores = [];
  fechaInicial = '';
  fechaFinal = '';
  estatus = [];

  constructor(private reportesService: ReportesService,
    private usuariosService: UsuarioService,
    private listasService: ListasService) { }

  ngOnInit(): void {
    this.listasService.getLists().subscribe(resp => {
      this.estatus = [];
      resp['data'].forEach(list => {
        if(list['attributes'].domain === 'CREDIT_STATUS'){
          this.estatus.push(list['attributes']);
        }
      });
      this.consultarQuotes();
    })
  }

  formatearFecha(fecha: Date): string {
    const año = fecha.getFullYear();
    const mes = fecha.getMonth() + 1; // Los meses van de 0 a 11
    const día = fecha.getDate();
    return `${año}-${mes}-${día}`;
  }

  consultaQuotesFechas(){
    this.consultarQuotes(this.fechaInicial, this.fechaFinal);
    this.fechaInicial = '';
    this.fechaFinal = '';
  }

  consultarQuotes(parametro?, parametro2?) {
    this.quotes = [];
    if(this.opcionSeleccionada === 'gpa') {
      this.reportesService.getReporteCreditosGPA().subscribe(resp => {
        resp.forEach(q => {
          q.estatus = this.estatus.find(e => e.key === q.estatus)?.value || q.estatus;
          this.quotes.push(q);
        })
      })
    } else if (this.opcionSeleccionada === 'yucatan') {
      this.reportesService.getReporteCreditosYucatan().subscribe(resp => {
        resp.forEach(q => {
          q.estatus = this.estatus.find(e => e.key === q.estatus)?.value || q.estatus;
          this.quotes.push(q);
        })
      })
    }
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }
  
  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }
  
  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }
  
  goToEllipsisPage(position: 'first' | 'last'): void {
    if (position === 'first') {
      this.currentPage = 1;
    } else if (position === 'last') {
      this.currentPage = this.totalPages;
    }
  }

  get totalPages(): number {
    return Math.ceil(this.filteredDataq.length / this.itemsPerPage);
  }

  get pages(): number[] {
    const totalPages = this.totalPages;
  
    if (totalPages <= this.maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
  
    const pages = [];
    const halfRange = Math.floor(this.maxVisiblePages / 2);
  
    let startPage = Math.max(1, this.currentPage - halfRange);
    let endPage = Math.min(totalPages, startPage + this.maxVisiblePages - 1);
  
    if (endPage === totalPages) {
      startPage = totalPages - this.maxVisiblePages + 1;
    }
    if (startPage === 1) {
      endPage = this.maxVisiblePages;
    }
  
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
  
    return pages;
  }

  pgone() {
    this.currentPage = 1;
  }

  sortData(column: string): void {
    // Cambia la dirección de ordenación si se selecciona la misma columna, de lo contrario reinicia a ascendente
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
  }

  private compare(a: any, b: any, column: string, direction: 'asc' | 'desc'): number {
    if (!column) return 0;
  
    const valueA = a[column];
    const valueB = b[column];
  
    let comparison = 0;
    if (valueA > valueB) {
      comparison = 1;
    } else if (valueA < valueB) {
      comparison = -1;
    }
  
    return direction === 'asc' ? comparison : -comparison;
  }

  exportExcelFil() {
    let fullData = this.filteredDataq
    const readOpts = {
        cellText: false, 
        cellDates: true,
    };
   // Generar los datos personalizados para exportación
   const dataToExport = fullData.map(item => {
    const base = {};

    // Agregar columna extra si la opción seleccionada es 'yucatan'
    if (this.opcionSeleccionada === 'yucatan') {
      this.colsYucatan.forEach(col => {
        base[col.header] = item[col.field] || '';
      })
    }else{
      this.colsGPA.forEach(col => {
        base[col.header] = item[col.field] || '';
      })
    }

    return base;
   });
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport, readOpts);
    const wb: XLSX.WorkBook = XLSX.utils.book_new(); 
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'creditos.xlsx', readOpts);
  }

  formatFecha(fecha: { split: (arg0: string) => [any, any, any]; }) {
    if (!fecha) return '';
    const [year, month, day] = fecha.split('-');
    return `${day}/${month}/${year}`;
  }
  
  removeCommas(monto: { toString: () => string; }) {
    if (!monto) return '';
    return monto.toString().replace(/,/g, ''); // Elimina todas las comas
  }

  get filteredDataq(): any[] {
    const filtered = this.quotes.filter(item => //return
      (!this.searchTerms.nombre_cliente || (item.nombre_cliente && item.nombre_cliente.toLowerCase().includes(this.searchTerms.nombre_cliente.toLowerCase()))) &&
      (!this.searchTerms.empresa || (item.empresa && item.empresa.toLowerCase().includes(this.searchTerms.empresa.toLowerCase()))) &&
      (!this.searchTerms.monto || (item.monto && item.monto.toLowerCase().includes(this.searchTerms.monto.toLowerCase()))) &&
      (!this.searchTerms.plazo || (item.plazo && item.plazo == this.searchTerms.plazo)) &&
      (!this.searchTerms.term_type || (item.term_type && item.term_type.toLowerCase().includes(this.searchTerms.term_type.toLowerCase()))) &&
      (!this.searchTerms.estatus || (item.estatus && item.estatus.toLowerCase().includes(this.searchTerms.estatus.toLowerCase()))) &&
      (!this.searchTerms.supervisor || (item.supervisor && item.supervisor.toLowerCase().includes(this.searchTerms.supervisor.toLowerCase()))) &&
      (!this.searchTerms.tasa || (item.tasa && item.tasa.toLowerCase().includes(this.searchTerms.tasa.toLowerCase()))) 
    );
    return filtered.sort((a, b) => this.compare(a, b, this.sortColumn, this.sortDirection));
  }

  get dataToShow(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return this.filteredDataq.slice(startIndex, startIndex + this.itemsPerPage);
  }

}
